// extracted by mini-css-extract-plugin
export default {"container":"GeneralErrorModal_container__eYOJV","buttonBack":"GeneralErrorModal_buttonBack__WzB2n"};